import React from 'react';
import './Hero.css';

const Hero = () => {
  // const heroStyle = {
  //   backgroundImage: `url(${process.env.PUBLIC_URL}/images/gardenia-apartments.png)`,
  //   backgroundSize: 'cover',
  //   backgroundPosition: 'center',
  //   backgroundRepeat: 'no-repeat',
  // };

  const heroStyle = {
    backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${process.env.PUBLIC_URL}/images/gardenia-apartments.png)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };
  
  return (
    <section className="hero" style={heroStyle}>
      <div className="hero-content">
        {/* <div className="hero-logo">JASPER</div> */}
        <h1 className="hero-title">Welcome to Jasper Group Estate</h1>
        <p className="hero-subtitle">
          Premium Real Estate Developments Across Prime Locations
        </p>
        <p className="hero-description">
          Discover luxury living and smart investment opportunities with Jasper Group Estate. 
          We offer world-class properties in carefully selected locations, designed for 
          modern living and long-term value.
        </p>
      </div>
    </section>
  );
};

export default Hero;

